import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FAQS } from "../data/faqs";
import { getFaqs } from "../services/veysoApi";
import { useApiData } from "../hooks/useApiData";
import FallbackNotice from "../components/FallbackNotice";
import { PageHero, Section } from "../components/ui";
import { tokens } from "../theme";

export default function Faqs() {
  const { data, usingFallback } = useApiData(getFaqs, FAQS.map((f, i) => ({ id: i, question: f.q, answer: f.a })));
  return (
    <>
      <PageHero eyebrow="FAQs" title="Questions, answered" subtitle="Sample answers for the preview build." />
      <Section tone="white" narrow>
        <FallbackNotice show={usingFallback} />
        {(data || []).map((f) => (
          <Accordion key={f.id} disableGutters elevation={0} sx={{ border: `1px solid ${tokens.line}`, mb: 1.5, borderRadius: "14px !important", "&:before": { display: "none" } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography sx={{ fontWeight: 600 }}>{f.question}</Typography></AccordionSummary>
            <AccordionDetails><Typography sx={{ color: tokens.muted }}>{f.answer}</Typography></AccordionDetails>
          </Accordion>
        ))}
      </Section>
    </>
  );
}
